// removed by extract-text-webpack-plugin
module.exports = {"hint":"index__hint___3BmEG","subjectsList":"index__subjectsList___1V5EK","subject":"index__subject___3_kMq","deleteIcon":"index__deleteIcon___2VC0Q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/SubjectsModal/index.less
// module id = 1232
// module chunks = 3